import styled from 'styled-components';
import { Box } from 'UI';

export const SFooterBox = styled(Box)`
  border-top: ${({ theme }) => `${theme.color.grey95} 15px solid`};
  margin-top: 45px;
`;
